// extracted by mini-css-extract-plugin
export default {"container":"PersonPhoto_container__pft2N","photo":"PersonPhoto_photo__-6Qfc","favorite":"PersonPhoto_favorite__nUYvl"};